import React from 'react';

function ReadOnly(_ref) {
  var article = _ref.article;
  return React.createElement("div", null, React.createElement("h1", {
    className: "ro-title",
    dangerouslySetInnerHTML: {
      __html: article.title
    }
  }), React.createElement("h2", {
    className: "ro-subtitle",
    dangerouslySetInnerHTML: {
      __html: article.subtitle
    }
  }), React.createElement("p", {
    className: "ro-text",
    dangerouslySetInnerHTML: {
      __html: article.text
    }
  }), React.createElement("p", {
    className: "ro-author",
    dangerouslySetInnerHTML: {
      __html: article.author
    }
  }), React.createElement("p", {
    className: "ro-about-author",
    dangerouslySetInnerHTML: {
      __html: article.about_author
    }
  }), React.createElement("p", {
    className: "ro-appendix",
    dangerouslySetInnerHTML: {
      __html: article.appendix
    }
  }), React.createElement("p", {
    className: "ro-photo-author",
    dangerouslySetInnerHTML: {
      __html: article.photo_author
    }
  }), React.createElement("p", {
    className: "ro-photo-caption",
    dangerouslySetInnerHTML: {
      __html: article.photo_caption
    }
  }), React.createElement("p", {
    className: "ro-advertisment",
    dangerouslySetInnerHTML: {
      __html: article.advertisement
    }
  }), React.createElement("p", {
    className: "ro-other-graphics",
    dangerouslySetInnerHTML: {
      __html: article.other_graphics
    }
  }), React.createElement("p", {
    className: "ro-unknown",
    dangerouslySetInnerHTML: {
      __html: article.unknown
    }
  }), React.createElement("p", {
    className: "ro-table",
    dangerouslySetInnerHTML: {
      __html: article.table
    }
  }), React.createElement("p", {
    className: "ro-section",
    dangerouslySetInnerHTML: {
      __html: article.section
    }
  }));
}

export default ReadOnly;